import React from 'react';
import { Box, Container, Typography } from '@mui/material';

export interface LayoutProps {
  children: React.ReactNode;
}

function LayoutNoAuth({ children }: LayoutProps) {
  return (
    <Container
      maxWidth="xs"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 0,
      }}
    >
      <Box component="img" src="/logo.png" alt="logo" />
      <Box sx={{ lineHeight: 1, mb: 5 }}>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            fontSize: 12,
          }}
        >
          Простой учёт доходов и расходов
        </Typography>
      </Box>
      {children}
    </Container>
  );
}

export default LayoutNoAuth;
